import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { RootState } from './core/stores/store';
import { selectAppError, selectAppIsLoading } from './core/stores/app/app.selectors';
import { ErrorComponent } from './features/error/error.component';
import { LoadingComponent } from './features/loading/loading.component';
import { CommonModule } from '@angular/common';
import { AppActions } from './core/stores/app/app.actions';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterModule,
    ErrorComponent,
    LoadingComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {

  appIsLoading$: Observable<number | undefined>;
  appError$: Observable<string | unknown | undefined>;

  constructor(
    private store: Store<RootState>,
  ) {
    this.appIsLoading$ = this.store.select(selectAppIsLoading);
    this.appError$ = this.store.select(selectAppError);
  }

  ngOnInit(): void {
    this.store.dispatch(AppActions.resetLoading());
  }

}